"use client"; 

import { RenderBlocks } from '../../components/RenderBlocks'
import { Page } from '@telesoft/types/payload-types'
import React from 'react'

export type Props = Extract<Page['blocks'][0], { blockType: 'reusable-blocks' }>

export const ReusableBlock: React.FC<Props> = ({ reusableContentBlockFields }) => {
  const { reusableBlock } = reusableContentBlockFields

  if (typeof reusableBlock === 'object' && reusableBlock !== null) {
    return <RenderBlocks blocks={reusableBlock.blocks} />
  }

  return null
}
